<template>
    <div class="article-contact">
        <p>Contact us with questions, suggestions, or just to say hello! We'd love to hear from you.</p>
        <p>
            <strong>St Chad’s Parish Centre<br /></strong>Otley Road, Far Headingley, Leeds, LS16 5JT
        </p>
        <p>West Coast Swing classes every Tuesday from 8:30pm. No partner, special clothes or experience required.</p>
    </div>
</template>

<script>
export default {
    name: 'ArticleContact',
};
</script>
